import React from 'react';
import Icon from '../../../components/AppIcon';

const LoginHeader = () => {
  return (
    <div className="text-center space-y-2 md:space-y-3 lg:space-y-4">
      <div className="flex justify-center">
        <div className="w-16 h-16 md:w-20 md:h-20 lg:w-24 lg:h-24 rounded-2xl bg-gradient-to-br from-primary to-accent flex items-center justify-center shadow-lg">
          <Icon name="Layers" size={32} className="text-primary-foreground md:w-10 md:h-10 lg:w-12 lg:h-12" />
        </div>
      </div>
      <h1 className="text-2xl md:text-3xl lg:text-4xl font-heading font-bold text-foreground">
        Welcome Back
      </h1>
      <p className="text-sm md:text-base lg:text-lg text-muted-foreground max-w-md mx-auto">
        Sign in to your DKS Creator account to continue building amazing web applications
      </p>
    </div>
  );
};

export default LoginHeader;